// src/NotificationBell.js
import React, { useState } from "react";
import { Bell } from "lucide-react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { initialStatuses } from "./statusConfig";

const activeStatuses = initialStatuses.filter(s => !s.disablesBadge).map(s => s.name);

const NotificationBell = ({ leads, onSelectLead }) => {
  const [open, setOpen] = useState(false);
  const [hasUnread, setHasUnread] = useState(true);

  const today = new Date();

  const expiredLeads = leads.filter(lead => {
    if (!lead.data_scadenza) return false;
    const scadenza = new Date(lead.data_scadenza);
    return scadenza < today && activeStatuses.includes(lead.stato); // 🔥 USIAMO activeStatuses
  });

  const handleOpenChange = (isOpen) => {
    setOpen(isOpen);
    if (isOpen) {
      setHasUnread(false);
    }
  };

  return (
    <DropdownMenu.Root open={open} onOpenChange={handleOpenChange}>
      <DropdownMenu.Trigger asChild>
        <div className="relative cursor-pointer">
          <Bell className="w-8 h-8" />
          {hasUnread && expiredLeads.length > 0 && (
            <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              {expiredLeads.length}
            </span>
          )}
        </div>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content
        className="bg-white rounded shadow p-2 w-64"
        sideOffset={10}
        align="end"
      >
        <div className="font-bold mb-2">Lead da gestire</div>
        {expiredLeads.length === 0 ? (
          <div className="text-gray-500">Nessun lead scaduto</div>
        ) : (
          expiredLeads.map(lead => (
            <div
              key={lead.id}
              className="p-2 hover:bg-gray-100 rounded cursor-pointer"
              onClick={() => onSelectLead(lead.id)}
            >
              <div className="font-semibold">{lead.nome}</div>
              <div className="text-xs text-gray-500">
                Scadenza: {new Date(lead.data_scadenza).toLocaleDateString()}
              </div>
            </div>
          ))
        )}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default NotificationBell;
